"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.finalRefundStatus = void 0;
const enums_1 = require("./enums");
exports.finalRefundStatus = [
    enums_1.RefundStatus.REFUNDED,
    enums_1.RefundStatus.FAILED
];
//# sourceMappingURL=vocabularies.js.map